export default "__VITE_ASSET__rTFp82H___"